/**
 * 侧边栏切换
 *
 * @date 2019-05-15
 * @author chenyongzheng
 * @type {{showHamburger: boolean}}
 */

// 定义常量state 状态对象
const state = {
    // 侧边栏开关 默认true
    showHamburger: true,
};

// 定义常量getter 实时监听state值
const getters = {
    /**
     * 切换侧边栏状态
     * @returns {boolean}
     */
    isShowHamburger() {
        return state.showHamburger;
    }
};

// 定义常量mutations 改变状态值 同步事务
const mutations = {
    /**
     * 同步改变侧边栏状态
     * @param state
     */
    showHamburger(state) {
        state.showHamburger = !state.showHamburger;
    }
};

// 定义常量actions 改变状态值 异步事务
const actions = {
    /**
     * 异步改变侧边栏状态
     * @param context
     */
    showHamburger(context) {
        context.commit('showHamburger');
    }
};

// 暴露模块
export default {
    //用于在全局引用此文里的方法时标识这一个的文件名
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/hamburger.js